import Head from "next/head"
import Image from "next/image"
import about from "../../assets/images/about/about.webp";
import results from "../../assets/images/about/why-shankar-ias-academy/top.webp";
import meet from "../../assets/images/about/why-shankar-ias-academy/inter.webp";
import test from "../../assets/images/about/why-shankar-ias-academy/test.webp";
import interview from "../../assets/images/about/why-shankar-ias-academy/interview.webp";
import online from "../../assets/images/about/why-shankar-ias-academy/online.webp";
import trust from "../../assets/images/about/why-shankar-ias-academy/trust.webp";
import coaching from "../../assets/images/about/why-shankar-ias-academy/coaching.webp";
import mentor from "../../assets/images/about/why-shankar-ias-academy/mentor.webp";
import star from "../../assets/images/about/why-shankar-ias-academy/trainers.webp";
import worl from "../../assets/images/about/why-shankar-ias-academy/infra.webp";
import home from "../../assets/images/about/why-shankar-ias-academy/home.webp";
import redrightarrow from "../../assets/images/contact/redrightarrow.png";
import styles from "./why-shankar-ias.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Link from "next/link";

const Why_Shankar_IAS_Academy = () => {
   
    return (
      <>
        <Head>
            <meta charset="UTF-8" />
            
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>Why us | Shankar IAS Academy</title>
            <meta name="title" content="Why us | Shankar IAS Academy" />
            <meta name="description" content="Why us? Shankar IAS Academy - where commitment meets results. Experience a transformative learning environment for your UPSC success." />
            <link rel="canonical" href="https://www.shankariasacademy.com/why-shankar-ias/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="Why us | Shankar IAS Academy" />
            <meta property="og:description" content="Why us? Shankar IAS Academy - where commitment meets results. Experience a transformative learning environment for your UPSC success." />
            <meta property="og:url" content="https://www.shankariasacademy.com/why-shankar-ias/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

      <Navbar title="about" />

        <div className="container">
            <div className="row">
                <div className="col pt-3 pt-md-4">
                    <h1 className={`${styles.pagemaintitle}`}>Why Shankar IAS Academy?</h1>
                </div>
            </div>
            <div className="row">
                <div className="col pt-2">
                    <Image src={about} className="img-fluid w-100" alt="Why Shankar IAS Academy" title="Why Shankar IAS Academy" /> 
                </div>
            </div>
        </div>

            <div className="container">
                <div className="row">

                    <div className="col py-md-5 py-4">
                        <div className="row">

                            <div className="col-md-6 col-lg-4 col-12 mb-3">
                                <div className={`${styles.classesborder} h-100`} style={{backgroundColor:"#F4F6F8"}}>
                                    <div className={`${styles.whyboxboxheight} p-4`}>
                                        <Image src={results} className="img-fluid" alt="Shankar Ias Academy - Head Office" title="Shankar Ias Academy - Head Office" />
                                        <p className={`${styles.acheivername} pt-3 mb-0 mb-md-2`}>Top Notch Results</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>2200+ of our students selected for IAS, IPS and other elite services.</p>
                                    </div>
                                    <hr className="mb-0" />
                                    <div className="px-4 pb-1 py-md-2 " style={{backgroundColor:"#FFFFFF"}}>
                                        {/* result page */}
                                        <Link href="/our-achievers">
                                            <div className="row">
                                                <div className="col-9 col-xl-10 align-self-center">
                                                    <p className={`${styles.redunderline} mb-0`} id={styles.directionline}>Results</p>
                                                </div>
                                                <div className="col-3 col-xl-2">
                                                    <Image src={redrightarrow} className={`${styles.img} img-fluid`} alt="arrow icon" title="Link" />
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6 col-lg-4 col-12 mb-3">
                                <div className={`${styles.classesborder} h-100`} style={{backgroundColor:"#F4F6F8"}}>
                                    <div className={`${styles.whyboxboxheight} p-4`}>
                                        <Image src={meet} className="img-fluid" alt="Student-Achiever Interaction" title="Student-Achiever Interaction" />
                                        <p className={`${styles.acheivername} pt-3 mb-0 mb-md-2`}>Student-Achiever Interaction</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>Regular interaction with 130+ of our successful and serving IAS, IPS, IFS officers.</p>
                                    </div>
                                    {/* <hr className="mb-0" />
                                    <div className="px-4 pb-1 py-md-2 " style={{backgroundColor:"#FFFFFF"}}>
                                        {/* upsc visiting faculty */}
                                      {/*  <Link href="/visiting-faculty-panel-members"> 
                                            <div className="row">
                                                <div className="col-9 col-xl-10 align-self-center">
                                                    <p className={`${styles.redunderline} mb-0`} id={styles.directionline}>Visiting Faculties</p>
                                                </div>
                                                <div className="col-3 col-xl-2">
                                                    <Image src={redrightarrow} className={`${styles.img} img-fluid`} alt="arrow icon" title="Link" />
                                                </div>
                                            </div>
                                        </Link>
                                    </div>*/}
                                </div>
                            </div>

                            <div className="col-md-6 col-lg-4 col-12 mb-3">
                                <div className={`${styles.classesborder} h-100`} style={{backgroundColor:"#F4F6F8"}}>
                                    <div className={`${styles.whyboxboxheight} p-4`}>
                                        <Image src={test} className="img-fluid" alt="Extensive Test Series" title="Extensive Test Series" />
                                        <p className={`${styles.acheivername} pt-3 mb-0 mb-md-2`}>Extensive Test Series</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>Mandatory tests ‐ Prelims (25 offline, 30 online), Mains (10 offline) with UPSC like evaluation parameters.</p>
                                    </div>
                                    <hr className="mb-0" />
                                    <div className="px-4 pb-1 py-md-2 " style={{backgroundColor:"#FFFFFF"}}>
                                        {/* prelims */}
                                        <Link href="/upsc-optional-test-series">
                                            <div className="row">
                                                <div className="col-9 col-xl-10 align-self-center">
                                                    <p className={`${styles.redunderline} mb-0`} id={styles.directionline}>Learn More</p>
                                                </div>
                                                <div className="col-3 col-xl-2">
                                                    <Image src={redrightarrow} className={`${styles.img} img-fluid`} alt="arrow icon" title="Link" />
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6 col-lg-4 col-12 mb-3">
                                <div className={`${styles.classesborder} h-100`} style={{backgroundColor:"#F4F6F8"}}>
                                    <div className={`${styles.whyboxboxheight} p-4`}>
                                        <Image src={interview} className="img-fluid" alt="FREE Interview Guidance" title="FREE Interview Guidance" />
                                        <p className={`${styles.acheivername} pt-3 mb-0 mb-md-2`}>FREE Interview Guidance</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>Extensive coaching for personality assessment tests and mock interviews by expert panellists.</p>
                                    </div>
                                    <hr className="mb-0" />
                                    <div className="px-4 pb-1 py-md-2 " style={{backgroundColor:"#FFFFFF"}}>
                                        {/* Interview 2022 Free Coaching */}
                                        <Link href="/upsc-interview">
                                            <div className="row">
                                                <div className="col-9 col-xl-10 align-self-center">
                                                    <p className={`${styles.redunderline} mb-0`} id={styles.directionline}>Learn More</p>
                                                </div>
                                                <div className="col-3 col-xl-2">
                                                    <Image src={redrightarrow} className={`${styles.img} img-fluid`} alt="arrow icon" title="Link" />
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6 col-lg-4 col-12 mb-3">
                                <div className={`${styles.classesborder} h-100`} style={{backgroundColor:"#F4F6F8"}}>
                                    <div className={`${styles.whyboxboxheight} p-4`}>
                                        <Image src={online} className="img-fluid" alt="Online Classes" title="Online Classes" />
                                        <p className={`${styles.acheivername} pt-3 mb-0 mb-md-2`}>Online Classes</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>India&apos;s first online course in the country that offers live two-way communication.</p>
                                    </div>
                                    <hr className="mb-0" />
                                    <div className="px-4 pb-1 py-md-2 " style={{backgroundColor:"#FFFFFF"}}>
                                        {/* Upsc Classroom And Online */}
                                        <Link href="/upsc-online-class">
                                            <div className="row">
                                                <div className="col-9 col-xl-10 align-self-center">
                                                    <p className={`${styles.redunderline} mb-0`} id={styles.directionline}>Learn More</p>
                                                </div>
                                                <div className="col-3 col-xl-2">
                                                    <Image src={redrightarrow} className={`${styles.img} img-fluid`} alt="arrow icon" title="Link" />
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6 col-lg-4 col-12 mb-3">
                                <div className={`${styles.classesborder} h-100`} style={{backgroundColor:"#F4F6F8"}}>
                                    <div className={`${styles.whyboxboxheight} p-4`}>
                                        <Image src={trust} className="img-fluid" alt="Most Trusted Academy" title="Most Trusted Academy" />
                                        <p className={`${styles.acheivername} pt-3 mb-0 mb-md-2`}>Most Trusted Academy</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>Preferred IAS coaching institute for training students of Ministry of Social Justice and Empowerment, Kapu Corporation (Govt. Of Andhra Pradesh), BC Welfare Department (Govt. Of Andhra Pradesh).</p>
                                    </div>
                                    <hr className="mb-0" />
                                    <div className="px-4 pb-1 py-md-2 " style={{backgroundColor:"#FFFFFF"}}>
                                        {/* About */}
                                        <Link href="/about-us">
                                            <div className="row">
                                                <div className="col-9 col-xl-10 align-self-center">
                                                    <p className={`${styles.redunderline} mb-0`} id={styles.directionline}>Learn More</p>
                                                </div>
                                                <div className="col-3 col-xl-2">
                                                    <Image src={redrightarrow} className={`${styles.img} img-fluid`} alt="arrow icon" title="Link" />
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6 col-lg-4 col-12 mb-3">
                                <div className={`${styles.classesborder} h-100`} style={{backgroundColor:"#F4F6F8"}}>
                                    <div className={`${styles.whyboxboxheight} p-4`}>
                                        <Image src={coaching} className="img-fluid" alt="Exhaustive Coaching" title="Exhaustive Coaching" />
                                        <p className={`${styles.acheivername} pt-3 mb-0 mb-md-2`}>Exhaustive Coaching</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>More than 200 classes of 150 minutes each on Prelims and Mains syllabus.</p>
                                    </div>
                                  
                                </div>
                            </div>

                            <div className="col-md-6 col-lg-4 col-12 mb-3">
                                <div className={`${styles.classesborder} h-100`} style={{backgroundColor:"#F4F6F8"}}>
                                    <div className={`${styles.whyboxboxheight} p-4`}>
                                        <Image src={mentor} className="img-fluid" alt="Mentorship Programme" title="Mentorship Programme" />
                                        <p className={`${styles.acheivername} pt-3 mb-0 mb-md-2`}>Mentorship Programme</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>360ᵒ mentoring for students by expert faculty to shape opinions and perspectives.</p>
                                    </div>
                                   
                                </div>
                            </div>

                            <div className="col-md-6 col-lg-4 col-12 mb-3">
                                <div className={`${styles.classesborder} h-100`} style={{backgroundColor:"#F4F6F8"}}>
                                    <div className={`${styles.whyboxboxheight} p-4`}>
                                        <Image src={star} className="img-fluid" alt="Experienced Trainers" title="Experienced Trainers" />
                                        <p className={`${styles.acheivername} pt-3 mb-0 mb-md-2`}>Experienced Trainers</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>Faculty who have first-hand experience in clearing different stages of the IAS examination.</p>
                                    </div>
                                    <hr className="mb-0" />
                                    <div className="px-4 pb-1 py-md-2 " style={{backgroundColor:"#FFFFFF"}}>
                                        {/* Faculty */}
                                        <Link href="/our-faculty"> 
                                            <div className="row">
                                                <div className="col-9 col-xl-10 align-self-center">
                                                    <p className={`${styles.redunderline} mb-0`} id={styles.directionline}>Our Faculties</p>
                                                </div>
                                                <div className="col-3 col-xl-2">
                                                    <Image src={redrightarrow} className={`${styles.img} img-fluid`} alt="arrow icon" title="Link" />
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6 col-lg-4 col-12 mb-3">
                                <div className={`${styles.classesborder} h-100`} style={{backgroundColor:"#F4F6F8"}}>
                                    <div className={`${styles.whyboxboxheight} p-4`}>
                                        <Image src={worl} className="img-fluid" alt="World Class Infrastructure" title="World Class Infrastructure" />
                                        <p className={`${styles.acheivername} pt-3 mb-0 mb-md-2`}>World Class Infrastructure</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>Two way interactive, world class learning centres with state-of-the-art infrastructure.</p>
                                    </div>
                                    <hr className="mb-0" />
                                    <div className="px-4 pb-1 py-md-2 " style={{backgroundColor:"#FFFFFF"}}>
                                        {/* infrastructure page */}
                                        <Link href="/our-infrastructure">
                                            <div className="row">
                                                <div className="col-9 col-xl-10 align-self-center">
                                                    <p className={`${styles.redunderline} mb-0`} id={styles.directionline}>Infrastucture</p>
                                                </div>
                                                <div className="col-3 col-xl-2">
                                                    <Image src={redrightarrow} className={`${styles.img} img-fluid`} alt="arrow icon" title="Link" />
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6 col-lg-4 col-12 mb-3">
                                <div className={`${styles.classesborder} h-100`} style={{backgroundColor:"#F4F6F8"}}>
                                    <div className={`${styles.whyboxboxheight} p-4`}>
                                        <Image src={home} className="img-fluid" alt="Home Away From Home" title="Home Away From Home" />
                                        <p className={`${styles.acheivername} pt-3 mb-0 mb-md-2`}>Home Away From Home</p>
                                        <p className={`${styles.acheiverrank} mb-0`}>We provide assistance for out station IAS, IPS aspirants to choose from over 40 hostels.</p>
                                    </div>
                                    <hr className="mb-0" />
                                    <div className="px-4 pb-1 py-md-2 " style={{backgroundColor:"#FFFFFF"}}>
                                        {/* hostel page */}
                                        <Link href="/our-infrastructure#Hostel">
                                            <div className="row">
                                                <div className="col-9 col-xl-10 align-self-center">
                                                    <p className={`${styles.redunderline} mb-0`} id={styles.directionline}>Hostels</p>
                                                </div>
                                                <div className="col-3 col-xl-2">
                                                    <Image src={redrightarrow} className={`${styles.img} img-fluid`} alt="arrow icon" title="Link" />
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
      </>
    )
  }
  
  export default Why_Shankar_IAS_Academy